import constants from "../constants.js";

export const EnhancedPolicyRulesActionsPnrRemarksExclusionRemarks = {
    displayName: "Exclusion Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.ExclusionRemarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };
  
export const EnhancedPolicyRulesActionsPnrRemarksStandardRemarks = {
    displayName: "Standard Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.StandardRemarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };
  
export const EnhancedPolicyRulesActionsPnrRemarksStandardRemarksInfo = {
    displayAs: constants.DISPLAY_AS.SUB_HEADING,
    html: "<ol start='0'>" + 
    "<li>Itinerary</li>" +
    "<li>ItineraryPassenger</li>" +
    "<li>List&ltItineraryPassengerHotel&gt</li>" +
    "<li>List&ltItineraryPassengerFlight&gt</li>" +
    "<li>List&ltItineraryPassengerCar&gt</li>" +
    "<li>Debtor</li>" +
    "<li>string Role</li>" +
    "<li>object GuestTraveller</li>" +
    "<li>ItineraryPassengerApprover</li>" +
    "<li>List&ltItineraryPassengerRail&gt</li>" +
    "<li>{ TimePolicyCode, TimePolicyTitle, IsInTimePolicy, LeadTimeForInPolicyBooking }</li>" +
    "<li>List&ltItineraryPassengerGroundTrans&gt</li>" +
    "<li>DateTime.Now</li>" +
    "<li>List&ltAirTicket&gt</li>" +
    "<li>List&ltRailTicket&gt</li>" +
    "<li>List&ltVirtualPayments&gt</li>" +
    "<li>List&ltVirtualPaymentCanceled&gt</li>" +
    "<li>{ LoggedInUserEmail, LoggedInUserName, LoggedInEmployeeCode, LoggedInEmployeeNumber, LoggedInEmployeeDepartment, LoggedInEmployeeCostCenter, LoggedInUserRole }</li>" +
"</ol>"
};

export const EnhancedPolicyRulesActionsPnrRemarksHostCommands = {
    displayName: "Host Commands",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.HostCommands",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksHostCommandsInfo = {
    displayAs: constants.DISPLAY_AS.SUB_HEADING,
    html: "<ol start='0'>" + 
    "<li>Debtor</li>" +
    "<li>ItineraryPassenger</li>" +
    "<li>object CurrentUser</li>" +
    "<li>CreditCardDetails</li>" +
    "<li>string PassengerCreditCardShortYear</li>" +
    "<li>List&ltAirTicket&gt</li>" +
    "<li>List&ltRailTicket&gt</li>" +
    "</ol>"
};

export const EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarksExclusions = {
    displayName: "Pre Trip Approval Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.PreTripApprovalRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarks = {
    displayName: "Pre Trip Approval Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.PreTripApprovalRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarksExclusions = {
    displayName: "Guest Traveller Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.GuestTravellerRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarks = {
    displayName: "Guest Traveller Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.GuestTravellerRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksApprovalRemarksExclusions = {
    displayName: "Approval Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ApprovalRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksApprovalRemarks = {
    displayName: "Approval Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ApprovalRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksExclusions = {
    displayName: "Declined Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.DeclinedRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarks = {
    displayName: "Declined Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.DeclinedRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableExclusions = {
    displayName: "Declined Remarks NonRefundable Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableRemarks = {
    displayName: "Declined Remarks NonRefundable Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksExpiredRemarksExclusions = {
    displayName: "Expired Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ExpiredRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksExpiredRemarks = {
    displayName: "Expired Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ExpiredRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksCancelRemarksExclusions = {
    displayName: "Cancel Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.CancelRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksCancelRemarks = {
    displayName: "Cancel Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.CancelRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksModifyRemarksExclusions = {
    displayName: "Modify Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ModifyRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksModifyRemarksRemarks = {
    displayName: "Modify Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ModifyRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarksExclusions = {
    displayName: "User Hold Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.UserHoldRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarks = {
    displayName: "User Hold Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.UserHoldRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarksExclusions = {
    displayName: "Expired User Hold Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ExpiredUserHoldRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarks = {
    displayName: "Expired User Hold Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ExpiredUserHoldRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarksExclusions = {
    displayName: "Confirmed User Hold Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ConfirmedUserHoldRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarks = {
    displayName: "Confirmed User Hold Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ConfirmedUserHoldRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksFinisherBookingRemarksExclusions = {
    displayName: "Finish Booking Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.FinishBookingRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksFinishBookingRemarksRemarks = {
    displayName: "Finish Booking Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.FinishBookingRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName = {
    displayName: "Name",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.Name",
    displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  };

export const EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions = {
    displayName: "Finishing Remarks Exclusions",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.FinishingRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks = {
    displayName: "Finishing Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.FinishingRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks = {
    displayName: "Seat Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.SeatRemarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks = {
    displayName: "Ancillary Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.AncillaryRemarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

export const EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem = {
    displayName: "Item",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem",
    displayAs: constants.DISPLAY_AS.RESOURCE,
    children: [
        EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName,
        EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions,
        EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks,
        EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks,
        EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks
    ],
    endpoint: "EnhancedPolicyRules",
    removeParamId: "EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem",
    canDelete: true,
  };

export const EnhancedPolicyRulesActionsPnrRemarksGdsRemarksGrid = {
    displayName: "Gds Remarks",
    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks",
    displayAs: constants.DISPLAY_AS.GRID,
    canCopyItem: true,
    canAddNew: true,
    gridItem: EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem,
    gridCols: [{ name: "Name", key: "Name" }],
};


// WEBPACK FOOTER //
// ./src/config/fields/enhancedPolicyRulesPnrRemarks.js